/**
 * Hub Medical
 * Hub medical Consorcio
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Address } from './address';
import { ProviderPJUser } from './providerPJUser';


export interface ProfileProviderPJ { 
    id?: number;
    phoneNumber?: string;
    cnesCode?: string;
    crmTechnicalNumber?: string;
    cnpj?: string;
    companyName?: string;
    companyMarketingName?: string;
    businesLicenseControlNumber?: string;
    pumblerLicenseControlNumber?: string;
    businessType?: ProfileProviderPJ.BusinessTypeEnum;
    email?: string;
    packageTypeRef?: ProfileProviderPJ.PackageTypeRefEnum;
    registerDate?: string;
    active?: boolean;
    status?: ProfileProviderPJ.StatusEnum;
    certifiedHubMedical?: boolean;
    providerPJUser?: Array<ProviderPJUser>;
    addresses?: Array<Address>;
}
export namespace ProfileProviderPJ {
    export type BusinessTypeEnum = 'HOSPITAL' | 'CLINICA' | 'HOMECARE' | 'DIAGNOSTICO' | 'HOSPITALDIA' | 'LABORATORIO' | 'PRONTOATENDIMENTO' | 'OPERADORA' | 'ADMINISTRADORHOSPITALAR';
    export const BusinessTypeEnum = {
        Hospital: 'HOSPITAL' as BusinessTypeEnum,
        Clinica: 'CLINICA' as BusinessTypeEnum,
        Homecare: 'HOMECARE' as BusinessTypeEnum,
        Diagnostico: 'DIAGNOSTICO' as BusinessTypeEnum,
        Hospitaldia: 'HOSPITALDIA' as BusinessTypeEnum,
        Laboratorio: 'LABORATORIO' as BusinessTypeEnum,
        Prontoatendimento: 'PRONTOATENDIMENTO' as BusinessTypeEnum,
        Operadora: 'OPERADORA' as BusinessTypeEnum,
        Administradorhospitalar: 'ADMINISTRADORHOSPITALAR' as BusinessTypeEnum
    };
    export type PackageTypeRefEnum = 'SUBSCRIPTION_PROVIDER_PF_FREE' | 'SUBSCRIPTION_PROVIDER_PF_BASIC' | 'SUBSCRIPTION_LAB_FREE' | 'SUBSCRIPTION_LAB_BASIC' | 'SUBSCRIPTION_PROVIDER_PJ_FREE' | 'SUBSCRIPTION_PROVIDER_PJ_2' | 'SUBSCRIPTION_PROVIDER_PJ_6' | 'SUBSCRIPTION_PROVIDER_PJ_10' | 'SUBSCRIPTION_PROVIDER_PJ_PERSONAL' | 'SUBSCRIPTION_PROVIDER_CONTRACTOR_PJ_FREE' | 'SUBSCRIPTION_PROVIDER_CONTRACTOR_PJ_100' | 'SUBSCRIPTION_PROVIDER_CONTRACTOR_PJ_PERSONAL' | 'SUBSCRIPTION_CONTRACTOR_PJ_120' | 'SUBSCRIPTION_CONTRACTOR_PJ_PERSONAL' | 'SUBSCRIPTION_ADMINISTRATOR';
    export const PackageTypeRefEnum = {
        ProviderPfFree: 'SUBSCRIPTION_PROVIDER_PF_FREE' as PackageTypeRefEnum,
        ProviderPfBasic: 'SUBSCRIPTION_PROVIDER_PF_BASIC' as PackageTypeRefEnum,
        LabFree: 'SUBSCRIPTION_LAB_FREE' as PackageTypeRefEnum,
        LabBasic: 'SUBSCRIPTION_LAB_BASIC' as PackageTypeRefEnum,
        ProviderPjFree: 'SUBSCRIPTION_PROVIDER_PJ_FREE' as PackageTypeRefEnum,
        ProviderPj2: 'SUBSCRIPTION_PROVIDER_PJ_2' as PackageTypeRefEnum,
        ProviderPj6: 'SUBSCRIPTION_PROVIDER_PJ_6' as PackageTypeRefEnum,
        ProviderPj10: 'SUBSCRIPTION_PROVIDER_PJ_10' as PackageTypeRefEnum,
        ProviderPjPersonal: 'SUBSCRIPTION_PROVIDER_PJ_PERSONAL' as PackageTypeRefEnum,
        ProviderContractorPjFree: 'SUBSCRIPTION_PROVIDER_CONTRACTOR_PJ_FREE' as PackageTypeRefEnum,
        ProviderContractorPj100: 'SUBSCRIPTION_PROVIDER_CONTRACTOR_PJ_100' as PackageTypeRefEnum,
        ProviderContractorPjPersonal: 'SUBSCRIPTION_PROVIDER_CONTRACTOR_PJ_PERSONAL' as PackageTypeRefEnum,
        ContractorPj120: 'SUBSCRIPTION_CONTRACTOR_PJ_120' as PackageTypeRefEnum,
        ContractorPjPersonal: 'SUBSCRIPTION_CONTRACTOR_PJ_PERSONAL' as PackageTypeRefEnum,
        Administrator: 'SUBSCRIPTION_ADMINISTRATOR' as PackageTypeRefEnum
    };
    export type StatusEnum = 'USER_ACTIVE' | 'USER_CADASTER_PROCESS' | 'PROVIDER_PF_ACTIVE' | 'PROVIDER_PF_EXPIRED_PLAN' | 'PROVIDER_PF_CADASTER_PROCESS' | 'PROVIDER_PJ_ACTIVE' | 'PROVIDER_PJ_EXPIRED_PLAN' | 'PROVIDER_PJ_CADASTER_PROCESS' | 'CUSTOMERSERVICE_OPENED' | 'CUSTOMERSERVICE_INCHAT' | 'CUSTOMERSERVICE_CLOSED';
    export const StatusEnum = {
        UserActive: 'USER_ACTIVE' as StatusEnum,
        UserCadasterProcess: 'USER_CADASTER_PROCESS' as StatusEnum,
        ProviderPfActive: 'PROVIDER_PF_ACTIVE' as StatusEnum,
        ProviderPfExpiredPlan: 'PROVIDER_PF_EXPIRED_PLAN' as StatusEnum,
        ProviderPfCadasterProcess: 'PROVIDER_PF_CADASTER_PROCESS' as StatusEnum,
        ProviderPjActive: 'PROVIDER_PJ_ACTIVE' as StatusEnum,
        ProviderPjExpiredPlan: 'PROVIDER_PJ_EXPIRED_PLAN' as StatusEnum,
        ProviderPjCadasterProcess: 'PROVIDER_PJ_CADASTER_PROCESS' as StatusEnum,
        CustomerserviceOpened: 'CUSTOMERSERVICE_OPENED' as StatusEnum,
        CustomerserviceInchat: 'CUSTOMERSERVICE_INCHAT' as StatusEnum,
        CustomerserviceClosed: 'CUSTOMERSERVICE_CLOSED' as StatusEnum
    };
}


